import React from "react";
import styles from "./Errormessage.module.css";
import Image from "next/image"; // Use Next.js Image component for optimized image loading
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Link from "next/link";

const ErrorSection: React.FC = () => {
  return (
    <div className={`${styles.errorSection} container`}>
      <Breadcrumbs />
      <div className={styles.errorContainer}>
        <div className={styles.errorImage}>
          <Image
            src="/assets/404-image.png" // Replace with the actual path to your 404 image
            alt="404 Error"
            title="404 Error"
            width={500} // Adjust width
            height={300} // Adjust height
          />
        </div>
        <p className={styles.errorMessage}>
          Sorry We Can&apos;t Find That Page!
        </p>
        <p className={styles.errorDescription}>
          The page you are looking for was moved, removed, renamed or never
          existed.
        </p>
        <Link
          href="/"
          title="Back to home"
          passHref
          className={styles.homeButton}
        >
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default ErrorSection;
